import React from "react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[hsl(var(--app-navy-deep))] text-white lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="noise-overlay" />
        <img src="/brand/emerge-logo-white.png" alt="EMERGE" className="relative h-10 w-auto self-start" />
        <div className="relative max-w-md">
          <p className="section-label !text-white/60">Client intake & scheduling</p>
          <h2 className="mt-3 text-4xl font-semibold leading-tight">Every family reaches the right care, on time.</h2>
          <p className="mt-4 text-base leading-relaxed text-white/75">
            Review new intake requests, coordinate appointments across the team and keep a clear record of every step - in one calm workspace.
          </p>
        </div>
        <p className="relative text-sm tracking-wide text-white/60">Hope | Recovery | Healing | Resilience</p>
        <div className="absolute -bottom-32 -right-24 h-80 w-80 rounded-full" style={{ background: "radial-gradient(closest-side, rgba(141,198,63,.35), rgba(141,198,63,0))" }} aria-hidden="true" />
      </div>
      <div className="flex items-center justify-center px-4 py-10 sm:px-8">
        <div className="w-full max-w-[420px]">
          <div className="mb-8 flex items-center gap-3 lg:hidden">
            <div className="rounded-[10px] bg-[hsl(var(--app-navy-deep))] px-3 py-2">
              <img src="/brand/emerge-logo-white.png" alt="EMERGE" className="h-6 w-auto" />
            </div>
          </div>
          <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-base text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function AuthInput({ label, id, error, hint, ...props }) {
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-sm font-semibold text-foreground">
        {label}
      </label>
      <input id={id} className="emerge-input" aria-invalid={!!error} {...props} />
      {hint && !error && <p className="mt-1.5 text-xs text-muted-foreground">{hint}</p>}
      {error && (
        <p className="field-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

export function PrimaryButton({ children, loading, ...props }) {
  return (
    <button
      type="submit"
      disabled={loading || props.disabled}
      className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-[10px] bg-primary px-5 text-base font-semibold text-white hover:bg-[hsl(var(--app-navy-deep))] disabled:opacity-60"
      style={{ transition: "background-color 180ms" }}
      {...props}
    >
      {children}
    </button>
  );
}
